import { render, staticRenderFns } from "./SalonRating.vue?vue&type=template&id=03d86c45&scoped=true&"
import script from "./SalonRating.vue?vue&type=script&lang=js&"
export * from "./SalonRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d86c45",
  null
  
)

export default component.exports